import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-swiper-button",
  "use": "icon-swiper-button-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-swiper-button\">\n  <rect width=\"32\" height=\"32\" rx=\"16\" />\n  <path d=\"M14 21l5-5-5-5v10z\" fill=\"#fff\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol